// extracted by mini-css-extract-plugin
export var hideEditor = "_ff-2";
export var infoIcon = "_ff-3";
export var label = "_ff-1";
export var labelContainer = "_ff-0";
export var readonlyText = "_ff-4";